import { Routes } from '@angular/router';
import { HomeComponent } from './main/home/home.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { ConfigurationDetailComponent } from './configuration/configuration-detail/configuration-detail.component';
import { ConfigurationSignInComponent } from './configuration/configuration-sign-in/configuration-sign-in.component';
import { MainComponent } from './main/main.component';
import { AboutUsComponent } from './main/about-us/about-us.component';
import { CostPlanComponent } from './main/cost-plan/cost-plan-component';
import { UnsavedChangesGuard } from './utils/unsaved-changes.guard';
import { ContactUsComponent } from './main/contact-us/contact-us.component';
import { ConfigurationUpdatePasswordComponent } from './configuration/configuration-update-password/configuration-update-password.component';

export const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        children: [{ path: '', component: HomeComponent }],
    },
    {
        path: 'main',
        component: MainComponent,
        children: [
            { path: 'home', component: HomeComponent },
            { path: 'about-us', component: AboutUsComponent },
            { path: 'cost-plan', component: CostPlanComponent, pathMatch: 'full', canDeactivate: [UnsavedChangesGuard] },
            { path: 'cost-plan/:planType', component: CostPlanComponent, canDeactivate: [UnsavedChangesGuard] },
            { path: 'contact-us', component: ContactUsComponent },
        ],
    },
    {
        path: 'configuration',
        component: ConfigurationComponent,
        children: [
            { path: 'sign-in', component: ConfigurationSignInComponent },
            { path: 'update-password', component: ConfigurationUpdatePasswordComponent },
            {
                path: 'detail',
                component: ConfigurationDetailComponent,
            },
        ],
    },
    { path: '**', redirectTo: '' },
];
